import handler from 'api/handler'

const prefix = '/admin/socialMediaSettings'

const methods = {
  get: args => handler({ method: 'get', url: prefix, args }),
  update: args => handler({ method: 'put', url: prefix, args }),
  triggerFetch: args => handler({ method: 'post', url: prefix + '/triggerFetch', args }),
  getStats: args => handler({ method: 'get', url: prefix + '/stats', args })
}

export default methods

